// @ts-nocheck
import { Box } from '@mui/material';
import { XGButton, XGInput, XGModal } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import SegmentedToggle from '../../../Common/SegmentedToggle/SegmentedToggle';
import './PassengerCollectionRoundModal.css';

const PassengerCollectionRoundModal = ({
  isOpen = false,
  isSubmitting = false,
  formState,
  setFormState,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation(['settings', 'common']);
  const isEditing = Boolean(
    formState?.passengercollectionroundid ||
    formState?.trippassengercollectionroundid
  );
  const anchorLabel =
    formState?.collectionanchortype === 'after_booking'
      ? t('daysAfterBooking').toLowerCase()
      : t('daysBeforeDeparture').toLowerCase();
  const sendDaysLabel = t('collectionRoundSendDays', {
    anchor: anchorLabel
  });
  const dueDaysLabel = t('collectionRoundDueDaysDynamic', {
    anchor: anchorLabel
  });
  const daysRequiredLabel = t('collectionRoundDaysRequiredDynamic', {
    anchor: anchorLabel
  });

  const handleFieldChange = (event) => {
    const { name, value } = event.target;

    setFormState((prev) => ({
      ...prev,
      [name]:
        name === 'dueoffsetdays' || name === 'sendoffsetdays'
          ? value.replace(/[^\d]/g, '')
          : value,
      errors: {
        ...prev.errors,
        [name]: ''
      }
    }));
  };

  return (
    <XGModal
      className='passenger-collection-round-modal-dialog'
      id='passenger-collection-round-modal'
      open={isOpen}
      dismissable={true}
      disableEscapeKeyDown={true}
      allowClosing={true}
      maxWidth='md'
      title={
        isEditing
          ? t('updateCollectionRound')
          : t('addPassengerCollectionRound')
      }
      labelledby={
        isEditing
          ? t('updateCollectionRound')
          : t('addPassengerCollectionRound')
      }
      onClose={onClose}
      actions={
        <Box className='passenger-collection-round-modal__actions'>
          <XGButton
            id='passenger-collection-round-modal-cancel'
            text={t('common:cancel')}
            type='secondary'
            size='medium'
            variant='outlined'
            onClick={onClose}
            disabled={isSubmitting}
          />
          <XGButton
            id='passenger-collection-round-modal-save'
            text={
              isEditing
                ? t('updateCollectionRound')
                : t('addPassengerCollectionRound')
            }
            type='primary'
            size='medium'
            variant='contained'
            onClick={onSubmit}
            disabled={isSubmitting}
          />
        </Box>
      }
    >
      <Box className='passenger-collection-round-modal'>
        <Box className='passenger-collection-round-modal__field-stack'>
          <Box className='passenger-collection-round-modal__field'>
            <label
              className='passenger-collection-round-modal__field-label'
              htmlFor='passenger-collection-round-name'
            >
              {t('collectionRoundName')}
              <span className='passenger-collection-round-modal__required'>
                *
              </span>
            </label>
          </Box>
          <XGInput
            className='passenger-collection-round-modal__input'
            id='passenger-collection-round-name'
            name='name'
            placeholder={t('enterCollectionRoundName')}
            type='text'
            value={formState?.name ?? ''}
            onChange={handleFieldChange}
            error={Boolean(formState?.errors?.name)}
            hint={formState?.errors?.name}
          />

          <span className='passenger-collection-round-modal__field-label'>
            {t('collectionRoundTimingBasedOn')}
          </span>
          <SegmentedToggle
            className='passenger-collection-round-modal__anchor-options'
            selectedValue={formState?.collectionanchortype}
            disabled={isSubmitting}
            onChange={(value) =>
              setFormState((prev) => ({
                ...prev,
                collectionanchortype: value,
                errors: {
                  ...prev.errors,
                  collectionanchortype: ''
                }
              }))
            }
            options={[
              {
                label: t('daysAfterBooking'),
                value: 'after_booking'
              },
              {
                label: t('daysBeforeDeparture'),
                value: 'before_departure'
              }
            ]}
          />
          {formState?.errors?.collectionanchortype && (
            <span className='error-text text-sm-regular'>
              {formState.errors.collectionanchortype}
            </span>
          )}

          <XGInput
            className='passenger-collection-round-modal__input'
            id='passenger-collection-round-send-offset-days'
            label={`${sendDaysLabel} *`}
            name='sendoffsetdays'
            placeholder={daysRequiredLabel}
            type='text'
            value={formState?.sendoffsetdays ?? ''}
            onChange={handleFieldChange}
            error={Boolean(formState?.errors?.sendoffsetdays)}
            hint={formState?.errors?.sendoffsetdays}
          />

          <XGInput
            className='passenger-collection-round-modal__input'
            id='passenger-collection-round-due-offset-days'
            label={`${dueDaysLabel} *`}
            name='dueoffsetdays'
            placeholder={daysRequiredLabel}
            type='text'
            value={formState?.dueoffsetdays ?? ''}
            onChange={handleFieldChange}
            error={Boolean(formState?.errors?.dueoffsetdays)}
            hint={formState?.errors?.dueoffsetdays}
          />
        </Box>
      </Box>
    </XGModal>
  );
};

PassengerCollectionRoundModal.propTypes = {
  isOpen: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  formState: PropTypes.object,
  setFormState: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};

export default PassengerCollectionRoundModal;
